import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnergyMapService {
  scenarioPlannerEditedSource = new Subject<boolean>();
  scenarioPlannerCloseSource = new Subject<boolean>();
  scenarioPlannerSaveChangesSource = new Subject<boolean>();
  municipalityChangedSource = new Subject<boolean>();
  lampsRefreshing = new BehaviorSubject<boolean>(false);
  showLocalSettingsSource = new Subject<boolean>();
  grossElectricityCostChangedSource = new Subject<number>();
  lampPopupClose = new Subject();

  scenarioPlannerEdited$ = this.scenarioPlannerEditedSource.asObservable();
  scenarioPlannerClose$ = this.scenarioPlannerCloseSource.asObservable();
  scenarioPlannerSaveChanges$ = this.scenarioPlannerSaveChangesSource.asObservable();
  muninicipalityChanged$ = this.municipalityChangedSource.asObservable();
  lampsRefreshing$ = this.lampsRefreshing.asObservable();
  showLocalSettings$ = this.showLocalSettingsSource.asObservable();
  grossElectricityCostChanged$ = this.grossElectricityCostChangedSource.asObservable();

  scenarioPlannerEdited(edited: boolean) {
    this.scenarioPlannerEditedSource.next(edited);
  }

  scenarioPlannerClose(close: boolean) {
    this.scenarioPlannerCloseSource.next(close);
  }

  scenarioPlannerSaveChanges(saveChanges: boolean) {
    this.scenarioPlannerSaveChangesSource.next(saveChanges);
  }

  municipalityChanged(changed: boolean) {
    this.municipalityChangedSource.next(changed);
  }

  lampsRefreshingChanged(isRefreshing: boolean) {
    this.lampsRefreshing.next(isRefreshing);
  }

  showLocalSetting(show: boolean) {
    this.showLocalSettingsSource.next(show);
  }

  grossElectricityCostChanged(price: number) {
    this.grossElectricityCostChangedSource.next(price);
  }
}
